import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "layout-overlay-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M6.24414 21.0024C6.24414 20.5882 6.57993 20.2524 6.99414 20.2524L16.9983 20.2524C17.4125 20.2524 17.7483 20.5882 17.7483 21.0024C17.7483 21.4167 17.4125 21.7524 16.9983 21.7524L6.99414 21.7524C6.57993 21.7524 6.24414 21.4167 6.24414 21.0024Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M6.24414 17.006C6.24414 16.5918 6.57993 16.256 6.99414 16.256L16.9983 16.256C17.4125 16.256 17.7483 16.5918 17.7483 17.006C17.7483 17.4202 17.4125 17.756 16.9983 17.756L6.99414 17.756C6.57993 17.756 6.24414 17.4202 6.24414 17.006Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M6.24414 13.0043C6.24414 12.5901 6.57993 12.2543 6.99414 12.2543L16.9983 12.2543C17.4125 12.2543 17.7483 12.5901 17.7483 13.0043C17.7483 13.4185 17.4125 13.7543 16.9983 13.7543L6.99414 13.7543C6.57993 13.7543 6.24414 13.4185 6.24414 13.0043Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M20.25 4.99732C20.25 4.30696 19.6904 3.74732 19 3.74732L5 3.74731C4.30965 3.74731 3.75 4.30696 3.75 4.99731L3.75 15.9973C3.75 16.4115 3.41421 16.7473 3 16.7473C2.58579 16.7473 2.25 16.4115 2.25 15.9973L2.25 4.99731C2.25 3.47853 3.48122 2.24731 5 2.24731L19 2.24732C20.5188 2.24732 21.75 3.47853 21.75 4.99732V15.9973C21.75 16.4115 21.4142 16.7473 21 16.7473C20.5858 16.7473 20.25 16.4115 20.25 15.9973V4.99732Z"
    }, null, -1)
  ])))
}
export default { render: render }